var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRows03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.6667 16.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0.833334 5.83333H15.8333M0.833334 10.8333H15.8333M4.83333 0.833334H11.8333C13.2335 0.833334 13.9335 0.833334 14.4683 1.10582C14.9387 1.3455 15.3212 1.72795 15.5608 2.19836C15.8333 2.73314 15.8333 3.4332 15.8333 4.83333V11.8333C15.8333 13.2335 15.8333 13.9335 15.5608 14.4683C15.3212 14.9387 14.9387 15.3212 14.4683 15.5608C13.9335 15.8333 13.2335 15.8333 11.8333 15.8333H4.83333C3.4332 15.8333 2.73314 15.8333 2.19836 15.5608C1.72795 15.3212 1.3455 14.9387 1.10582 14.4683C0.833334 13.9335 0.833334 13.2335 0.833334 11.8333V4.83333C0.833334 3.4332 0.833334 2.73314 1.10582 2.19836C1.3455 1.72795 1.72795 1.3455 2.19836 1.10582C2.73314 0.833334 3.4332 0.833334 4.83333 0.833334Z",
    stroke: "var(--stroke-0, #5B652D)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRows03);
export default __webpack_public_path__ + "static/media/rows-03.234ed81f93f3126eeb1c918b66d6af5a.svg";
export { ForwardRef as ReactComponent };